import React from "react";
import { NavDropdown } from "react-bootstrap";
import {
  FaEyeSlash,
  FaSortAmountDownAlt,
  FaSortAmountUpAlt,
} from "react-icons/fa";
import { IoMdArrowDropdown } from "react-icons/io";

import { handleFieldHide, handleFieldSort } from "../../utils/helpers";
import "./dropdown.css";

/**
 * ActiveDropdownComponent (BooleanDropdown)
 * 
 * Dropdown menu component for datatable column operations. Provides sort ascending/descending
 * and hide field options for individual datatable columns. Used alongside datatable headers
 * to allow users to dynamically reorder and manage visible columns.
 * 
 * @param {Object} props - Component props containing datatable state and dispatch
 * @param {string} field - Column field name to apply sort or hide operation
 * @param {boolean} primary - Flag indicating if this is a primary/main column
 * @returns {JSX.Element} NavDropdown with sort and hide options
 */
const ActiveDropdownComponent = ({ props, field, primary }) => {
  return (
    <>
      <NavDropdown
        align="end"
        className="sort-navbardropdown"
        title={<IoMdArrowDropdown className="sort-navbaricon" />}
        id="basic-nav-dropdown"
        style={{ height: "100%" }}
      >
        <NavDropdown.Item
          onClick={() => handleFieldSort(props, field, " Sort Z to A")}
          className="sort-navbardropdownitem"
          id="sort-navbaractive"
        >
          <FaSortAmountDownAlt /> Sort A to Z
        </NavDropdown.Item>
        <NavDropdown.Item
          onClick={() => handleFieldSort(props, field, " Sort A to Z")}
          className="sort-navbardropdownitem"
          id="sort-navbaractive"
        >
          <FaSortAmountUpAlt /> Sort Z to A
        </NavDropdown.Item>

        <NavDropdown.Item
          onClick={() => handleFieldHide(props, field)}
          className="sort-navbardropdownitem"
          id="sort-navbaractive"
        >
          <FaEyeSlash /> Hide Field
        </NavDropdown.Item>
      </NavDropdown>
    </>
  );
};

export default ActiveDropdownComponent;
